














































































import { NewsEventNotice } from '../../../src_server/entity/generated/NewsEventNotice';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { EventAndNewsService } from '../../biz/remote/EventAndNewsService';
import { MessageDialog } from '../../utils/MessageDialog';
import { dayjs, DT_FORMAT_INPUT, DT_FORMAT_JA } from '../../../src_server/common/momentExtends';
@Component({
  components: {},
  filters: {
    dateFormat: (date: Date) => {
      if (!date) {
        return '';
      }
      return dayjs(date).format(DT_FORMAT_JA);
    },
  },
})
export default class EventNewsAdminPage extends Vue {
  private rows: NewsEventNotice[] = [];

  async created() {
    const biz = new EventAndNewsService();
    const response = await biz.getAll();
    this.rows = response.data;
  }

  dateToEdit(dt: Date) {
    return dayjs(dt).format(DT_FORMAT_INPUT);
  }

  async addNew() {
    const biz = new EventAndNewsService();
    const response = await biz.add();
    const row = new NewsEventNotice();
    row.notice_id = response.data; // レスポンスは新規ID
    row.title = '';
    row.contents_url = '';
    row.notice_start_dt = new Date();
    row.notice_end_dt = new Date();
    row.notice_type = 'event';
    this.rows.push(row);
  }

  edit(row: NewsEventNotice) {
    this.$set(row, 'editMode', true);
  }

  async commit(row: NewsEventNotice) {
    this.$set(row, 'editMode', false);
    const isOk = await MessageDialog.confirm('登録しますよろしいですか？');
    if (isOk) {
      const biz = new EventAndNewsService();
      await biz.update(row);
      this.$set(row, 'editMode', false);
      await MessageDialog.alert('登録が完了しました。');
    }
  }

  cancel(row: NewsEventNotice) {
    this.$set(row, 'editMode', false);
    console.log('edit');
  }

  async deleteItem(row: NewsEventNotice) {
    if (!row.notice_id) {
      await MessageDialog.systemError('掲示ID', 'イベント・ニュース削除時');
      return;
    }
    const isOk = await MessageDialog.confirm('このデータをします。削除すると復元できません。よろしいですか？');
    if (isOk) {
      const biz = new EventAndNewsService();
      await biz.delete(row.notice_id);
      this.$set(row, 'editMode', false);
      const index = this.rows.findIndex((item) => item.notice_id === row.notice_id);
      this.rows.splice(index, 1);
      await MessageDialog.alert('削除が完了しました。');
    }
  }
}
